<section class="table-wrapper">
    <table class="table" matSort (matSortChange)="sortColumn($event)">
        <tr class="th-row">
            <th mat-sort-header="frequencyValue" class="th-data">
                <div class="title-group pointer">
                    <span>Month & Year</span>
                    <div class="sort-group">
                        <mat-icon class="sorting-icons">arrow_drop_up</mat-icon>
                        <mat-icon class="sorting-icons">arrow_drop_down</mat-icon>
                    </div>
                </div>
            </th>
            <th mat-sort-header="investmentAmount" class="th-data">
                <div class="title-group pointer">
                    <span>New Investment</span>
                    <div class="sort-group">
                        <mat-icon class="sorting-icons">arrow_drop_up</mat-icon>
                        <mat-icon class="sorting-icons">arrow_drop_down</mat-icon>
                    </div>
                </div>
            </th>
            <th mat-sort-header="nCashAmount" class="th-data">
                <div class="title-group pointer">
                    <span>nCash</span>
                    <div class="sort-group">
                        <mat-icon class="sorting-icons">arrow_drop_up</mat-icon>
                        <mat-icon class="sorting-icons">arrow_drop_down</mat-icon>
                    </div>
                </div>
            </th>
            <th mat-sort-header="withdrawalAmount" class="th-data">
                <div class="title-group pointer">
                    <span>Withdrawal</span>
                    <div class="sort-group">
                        <mat-icon class="sorting-icons">arrow_drop_up</mat-icon>
                        <mat-icon class="sorting-icons">arrow_drop_down</mat-icon>
                    </div>
                </div>
            </th>
            <th mat-sort-header="interestAmount" class="th-data">
                <div class="title-group pointer">
                    <span>Interest</span>
                    <div class="sort-group">
                        <mat-icon class="sorting-icons">arrow_drop_up</mat-icon>
                        <mat-icon class="sorting-icons">arrow_drop_down</mat-icon>
                    </div>
                </div>
            </th>
            <th mat-sort-header="creditLoss" class="th-data">
                <div class="title-group pointer">
                    <span>Credit Loss</span>
                    <div class="sort-group">
                        <mat-icon class="sorting-icons">arrow_drop_up</mat-icon>
                        <mat-icon class="sorting-icons">arrow_drop_down</mat-icon>
                    </div>
                </div>
            </th>
            <th mat-sort-header="principalOutstanding" class="th-data">
                <div class="title-group pointer">
                    <span>Principal Outstanding</span>
                    <div class="sort-group">
                        <mat-icon class="sorting-icons">arrow_drop_up</mat-icon>
                        <mat-icon class="sorting-icons">arrow_drop_down</mat-icon>
                    </div>
                </div>
            </th>
        </tr>
        <tbody class="table-body">
            <tr class="tb-row" *ngFor="let lrs of lrsReportList?.data;">
                <td class="tb-data">{{lrs.frequencyValue | date:'MMM yyyy'}}</td>
                <td class="tb-data">&#8377; {{ lrs.investmentAmount | currency:'INR': ''}}</td>
                <td class="tb-data">&#8377; {{ lrs.nCashAmount | currency:'INR': ''}}</td>
                <td class="tb-data">&#8377; {{ (lrs.withdrawalAmount + lrs.interestWdAmount) | currency:'INR': ''}}</td>
                <td class="tb-data">&#8377; {{ lrs.interestAmount | currency:'INR': ''}}</td>
                <td class="tb-data">&#8377; {{ lrs.creditLoss | currency:'INR': ''}}</td>
                <td class="tb-data">&#8377; {{ (lrs.principalOutstanding || 0.0) | currency:'INR': ''}} </td>
            </tr>
        </tbody>
    </table>
</section>

<article class="responsive-table">
    <mat-accordion>
        <section matSort (matSortChange)="sortColumn($event)" class="header-table">
            <div mat-sort-header="frequencyValue" class="header-cell month-cell">
                <div class="title-group pointer">
                    <span>Month & Year</span>
                    <div class="sort-group">
                        <mat-icon class="sorting-icons">arrow_drop_up</mat-icon>
                        <mat-icon class="sorting-icons">arrow_drop_down</mat-icon>
                    </div>
                </div>
            </div>
            <div mat-sort-header="investmentAmount" class="header-cell">
                <div class="title-group pointer">
                    <span>New Investment</span>
                    <div class="sort-group">
                        <mat-icon class="sorting-icons">arrow_drop_up</mat-icon>
                        <mat-icon class="sorting-icons">arrow_drop_down</mat-icon>
                    </div>
                </div>
            </div>
            <div mat-sort-header="principalOutstanding" class="header-cell">
                <div class="title-group pointer">
                    <span>Principal Outstanding</span>
                    <div class="sort-group">
                        <mat-icon class="sorting-icons">arrow_drop_up</mat-icon>
                        <mat-icon class="sorting-icons">arrow_drop_down</mat-icon>
                    </div>
                </div>
            </div>
        </section>
        <section class="body-table">
            <mat-expansion-panel *ngFor="let lrs of lrsReportList?.data;" class="expansion-panel">
                <mat-expansion-panel-header class="expansion-panel-header">
                    <div class="body-cell date-body">
                        <div class="data-text small-font grey-text">
                            <span>{{lrs.frequencyValue | date:'MMM yyyy'}}</span>
                        </div>
                    </div>
                    <div class="body-cell">
                        <div class="data-text small-font grey-text invest-amount">
                            <span>&#8377; {{ lrs.investmentAmount | currency:'INR': ''}}</span>
                        </div>
                    </div>
                    <div class="body-cell principle-outstanding">
                        <div class="data-text small-font grey-text outstanding-amt">
                            <span>&#8377; {{ (lrs.principalOutstanding || 0.0) | currency:'INR': ''}}</span>
                        </div>
                    </div>
                </mat-expansion-panel-header>
                <mat-panel-description class="description-panel">
                    <div class="group-data">
                        <div class="group-data-label">
                            nCash
                        </div>
                        <div class="group-data-body">
                            &#8377; {{ lrs.nCashAmount | currency:'INR': ''}}
                        </div>
                    </div>
                    <div class="group-data">
                        <div class="group-data-label">
                            Withdrawal
                        </div>
                        <div class="group-data-body">
                            &#8377; {{ lrs.withdrawalAmount | currency:'INR': ''}}
                        </div>
                    </div>
                    <div class="group-data">
                        <div class="group-data-label">
                            Interest
                        </div>
                        <div class="group-data-body">
                            &#8377; {{ lrs.interestAmount | currency:'INR': ''}}
                        </div>
                    </div>
                    <div class="group-data">
                        <div class="group-data-label">
                            Credit Loss
                        </div>
                        <div class="group-data-body">
                            &#8377; {{ lrs.creditLoss | currency:'INR': ''}}
                        </div>
                    </div>
                </mat-panel-description>
            </mat-expansion-panel>
        </section>
    </mat-accordion>
</article>


